import { Observable } from "rxjs";
import { UseCase } from "../../../base/usecases";
import { Metadata } from "src/app/base/model/data-body-request";
import { UpdatePersonRepository } from "../../repositories/update-person/update-person.repository";
import { TypePersonUpdate } from "../../model/TypePersonUpdate";
import { ProcessedDataResponse } from "src/app/base/model/processed-data-response";

export class UpdatePersonUseCase implements UseCase<{}, ProcessedDataResponse<any>> {
    constructor(private updatePersonRepository:  UpdatePersonRepository) { }
    execute(
        params: {
            personId: number,
            typePersonUpdate: TypePersonUpdate,
            metadata: Metadata,
        },
    ): Observable<ProcessedDataResponse<any>> {
        return this.updatePersonRepository.updatePerson(params);
    }
}